import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const PageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  justifyContent: 'space-around',
  alignItems: 'center',
  gap: 100,
  padding: '100px 20px',
  [theme.breakpoints.down('md')]: {
    gap: 60,
    padding: '60px 20px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: 40,
    padding: '40px 0',
  },
}));
